import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { portFetchAll } from '../../actions/portAction'
import { AvForm, AvInput } from 'availity-reactstrap-validation'
import { muatanPerWilayah } from '../../actions/dashboardAction'
import { jenisbarangFetchAll } from '../../actions/jenisbarangAction'
import { Row, Col, Card, CardHeader, CardBody, CardFooter, Button, FormGroup, Table, Pagination, PaginationItem, PaginationLink, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'

let isDefaultMonth = false
let isDefaultWilayah = false
let isDefaultJenisBarang = false
let month_option = [
  { value: 1, label: 'Januari' },
  { value: 2, label: 'Februari' },
  { value: 3, label: 'Maret' },
  { value: 4, label: 'April' },
  { value: 5, label: 'Mei' },
  { value: 6, label: 'Juni' },
  { value: 7, label: 'Juli' },
  { value: 8, label: 'Agustus' },
  { value: 9, label: 'September' },
  { value: 10, label: 'Oktober' },
  { value: 11, label: 'November' },
  { value: 12, label: 'Desember' }
]

class MuatanPerWilayah extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 10,
      month: '',
      month_label: '',
      wilayah: '',
      wilayah_label: '',
      date_start: '',
      date_end: '',
      jenis_barang: '',
      jenis_barang_label: '',
      nama_barang: '',
      route: []
    }

    this.selectMonth = this.selectMonth.bind(this)
    this.selectWilayah = this.selectWilayah.bind(this)
    this.selectJenisBarang = this.selectJenisBarang.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      length: 10
    }

    this.props.muatanPerWilayah(data)
    this.props.portFetchAll()
    this.props.jenisbarangFetchAll()
  }

  componentWillUnmount() {
    isDefaultMonth = false
    isDefaultWilayah = false
    isDefaultJenisBarang = false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        month: this.state.month,
        wilayah: this.state.wilayah,
        date_start: this.state.date_start,
        date_end: this.state.date_end,
        jenis_barang: this.state.jenis_barang,
        nama_barang: this.state.nama_barang
      }

      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 10) - 10
        data.start = offset
      }

      this.props.muatanPerWilayah(data)
    }
  }

  selectMonth(opt) {
    if (opt) {
      this.setState({
        month: opt.value,
        month_label: opt.label
      })
    } else {
      this.setState({
        month: '',
        month_label: ''
      })
    }
  }

  selectWilayah(opt) {
    if (opt) {
      this.setState({
        wilayah: opt.value,
        wilayah_label: opt.label
      })
    } else {
      this.setState({
        wilayah: '',
        wilayah_label: ''
      })
    }
  }

  selectJenisBarang(opt) {
    if (opt) {
      this.setState({
        jenis_barang: opt.value,
        jenis_barang_label: opt.label
      })
    } else {
      this.setState({
        jenis_barang: '',
        jenis_barang_label: ''
      })
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  handleFilter(event, values) {
    if (this.state.month) {
      values.month = this.state.month
      isDefaultMonth = true
    } else {
      delete values.month
      isDefaultMonth = false
    }

    if (this.state.wilayah) {
      values.wilayah = this.state.wilayah
      isDefaultWilayah = true
    } else {
      delete values.wilayah
      isDefaultWilayah = false
    }

    if (this.state.jenis_barang) {
      values.jenis_barang = this.state.jenis_barang
      isDefaultJenisBarang = true
    } else {
      delete values.jenis_barang
      isDefaultJenisBarang = false
    }

    this.setState({
      date_start: values.date_start,
      date_end: values.date_end,
      nama_barang: values.nama_barang
    })

    values.length = this.state.perPage

    this.props.muatanPerWilayah(values)
  }

  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }

    return rupiah
  }

  renderData() {
    if (this.props.muatanPerWilayahIsSuccess) {
      let defaultValues = {
        month: this.state.month,
        month_label: this.state.month_label,
        wilayah: this.state.wilayah,
        wilayah_label: this.state.wilayah_label,
        date_start: this.state.date_start,
        date_end: this.state.date_end,
        jenis_barang: this.state.jenis_barang,
        jenis_barang_label: this.state.jenis_barang_label,
        nama_barang: this.state.nama_barang
      }

      const prevPage = parseInt(this.props.muatanPerWilayahData.currentPage) - 1
      const nextPage = parseInt(this.props.muatanPerWilayahData.currentPage) + 1

      let curPage = this.props.muatanPerWilayahData.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.muatanPerWilayahData.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      const { month } = this.state.month
      const { wilayah } = this.state.wilayah
      const { jenis_barang } = this.state.jenis_barang
      const defaultValueMonth = { label: defaultValues.month_label, value: defaultValues.month }
      const defaultValueWilayah = { label: defaultValues.wilayah_label, value: defaultValues.wilayah }
      const defaultValueJenisBarang = { label: defaultValues.jenis_barang_label, value: defaultValues.jenis_barang }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Total Muatan Per Wilayah</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Select name="month"
                        value={month}
                        isClearable
                        placeholder="Bulan..."
                        defaultValue={isDefaultMonth ? defaultValueMonth : false}
                        onChange={this.selectMonth}
                        options={month_option}
                        id="month"
                        inputId="input_month"
                        instanceId="instance_month"
                      />
                    </FormGroup>
                  </Col>
                  {this.props.portIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select name="wilayah"
                          value={wilayah}
                          isClearable
                          placeholder="Wilayah..."
                          defaultValue={isDefaultWilayah ? defaultValueWilayah : false}
                          onChange={this.selectWilayah}
                          options={this.props.ports.data}
                          id="wilayah"
                          inputId="input_wilayah"
                          instanceId="instance_wilayah"
                        />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.jenisbarangIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select name="jenis_barang"
                          value={jenis_barang}
                          isClearable
                          placeholder="Jenis Barang..."
                          defaultValue={isDefaultJenisBarang ? defaultValueJenisBarang : false}
                          onChange={this.selectJenisBarang}
                          options={this.props.jenisbarang.data}
                          id="jenis_barang"
                          inputId="input_jenis_barang"
                          instanceId="instance_jenis_barang" />
                      </FormGroup>
                    </Col>
                  }
                </Row>
                <Row>
                  <Col md="3">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Nama Barang</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="text" name="nama_barang" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Dari</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="date" name="date_start" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>Sampai</InputGroupText>
                        </InputGroupAddon>
                        <AvInput type="date" name="date_end" />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1">
                        <i className="fa fa-search"></i> <span>Proses </span>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody className="p-0">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>Wilayah</th>
                    <th>Jenis Barang</th>
                    <th>Nama Barang</th>
                    <th>Total Muatan (Kg)</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.muatanPerWilayahData.data.map((item, key) => {
                    let first = true
                    let rowSpanCount = 0
                    item.barangs.map(c => {
                      if (c) rowSpanCount++

                      return rowSpanCount
                    })

                    return item.barangs.map((barang, keyBarang) => {

                      if (barang !== null) {
                        if (first) {
                          first = false
                          return (
                            <tr key={keyBarang}>
                              <td rowSpan={rowSpanCount} className="">{item.pelabuhan}</td>
                              <td>
                                {barang.jenis_barang}
                              </td>
                              <td>
                                {/* {barang.nama_barang &&
                                  barang.nama_barang.join(', ')
                                } */}
                              </td>
                              <td className="" rowSpan={rowSpanCount}>{(item.total_muatan === null) ? 0 : this.changeRupiah(item.total_muatan)}</td>
                            </tr>
                          )

                        } else {

                          return (
                            <tr key={keyBarang}>
                              <td>
                                {barang.jenis_barang}
                              </td>
                              <td>
                                {barang.nama_barang &&
                                  barang.nama_barang.join(', ')
                                }
                              </td>
                            </tr>
                          )

                        }

                      }
                      // else {
                      //   return <tr><td rowSpan="4"></td></tr>
                      // }
                    })

                  })}
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination>
                {this.props.muatanPerWilayahData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                      First Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.muatanPerWilayahData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                      Prev
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {pages.map((item, index) => {
                  let actived = false
                  if (curPage === undefined) {
                    curPage = 1
                  }

                  if (item == curPage) {
                    actived = true
                  }

                  if (item >= minPage && item <= maxPage) {
                    return <PaginationItem active={actived} key={index}>
                      <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  }
                })}

                {this.props.muatanPerWilayahData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                      Next
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.muatanPerWilayahData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                      Last Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }
              </Pagination>

              {this.props.muatanPerWilayahData.pageTotal > 0 &&
                <p>Page: {this.props.muatanPerWilayahData.currentPage} of {this.props.muatanPerWilayahData.pageTotal}</p>
              }
            </CardFooter>
          </Card>
        </div>
      )
    }
  }

  render() {
    if (this.props.muatanPerWilayahIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.muatanPerWilayahHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }
}

MuatanPerWilayah.propTypes = {
  muatanPerWilayahIsSuccess: PropTypes.bool.isRequired,
  muatanPerWilayahHasError: PropTypes.bool.isRequired,
  muatanPerWilayahIsLoading: PropTypes.bool.isRequired,

  portIsSuccess: PropTypes.bool.isRequired,
  portHasError: PropTypes.bool.isRequired,
  portIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    muatanPerWilayahData: state.dashboard.muatanPerWilayahData,
    muatanPerWilayahIsSuccess: state.dashboard.muatanPerWilayahSuccess,
    muatanPerWilayahHasError: state.dashboard.muatanPerWilayahError,
    muatanPerWilayahIsLoading: state.dashboard.muatanPerWilayahLoading,

    ports: state.ports.ports,
    portIsSuccess: state.ports.portGetSuccess,
    portHasError: state.ports.portGetError,
    portIsLoading: state.ports.portGetLoading,

    jenisbarangIsSuccess: state.jenisbarangs.jenisbarangGetSuccess,
    jenisbarangHasError: state.jenisbarangs.jenisbarangGetError,
    jenisbarangIsLoading: state.jenisbarangs.jenisbarangGetLoading,
    jenisbarang: state.jenisbarangs.jenisbarangs
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    muatanPerWilayah: (data) => dispatch(muatanPerWilayah(data)),
    portFetchAll: () => dispatch(portFetchAll()),
    jenisbarangFetchAll: () => dispatch(jenisbarangFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MuatanPerWilayah)